import { createStyles, fade, Theme, withStyles, makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

interface MakeStylesProps {
	width?: string | undefined;
	height?: string | undefined;
}
export const useStyles = makeStyles<Theme, MakeStylesProps>((theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		margin: {
			margin: 0,
			width: 'inherit'
		},
		display: {
			position: 'absolute',
			right: 0,
		},
		link: {
			color: '#05042E',
			fontSize: '16px',
			fontFamily: 'Poppins',
		},
		label: {
			fontSize: '18px',
			fontFamily: 'Poppins',
		},
		inputs: {
			width: ({ width }) => `${width ? width : 'inherit'}`,
			height: ({ height }) => `${height ? height : 'inherit'}`,
			fontSize: '14px',
			fontFamily: 'Poppins',
			// [theme.breakpoints.down('xs')]: {
			// 	width: '250px !important',
			// 	fontSize: '12px',
			// }
		},
	}),
);

// simple component that styles the input using
export const ChildInput = withStyles((theme: Theme) =>
	createStyles({
		root: {
			'label + &': {
				marginTop: theme.spacing(3),
				fontSize: '18px',
				fontFamily: 'Poppins',
			},
		},
		input: {
			borderRadius: 200,
			position: 'relative',
			background: '#F1F6FA',
			border: '1px solid #7FD6DD',
			fontSize: '14px',
			width: 'inherit',
			height: 'auto',
			padding: '14px 40px 14px 20px',
			transition: theme.transitions.create(['border-color', 'box-shadow']),
			borderColor: '#0AC9D9',
			fontFamily: ['Poppins'].join(','),
			'&:placeholder': {
				fontFamily: 'Poppins',
			},
			'&:focus': {
				boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
				borderColor: '#33F0FF',
			},
		// 	'&::-webkit-calendar-picker-indicator': {
    //   display: 'none',
    //   '-webkit-appearance': 'none'
    // },
			[theme.breakpoints.down('xs')]: {
				// width: '203.24px',
			},
		},
	}),
)(InputBase);
